import { useCallback } from 'react';
import { useCountryState, useSelectedWIR } from 'redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WIR } from 'types/wellGuardian';

import { useSectionData } from './useSectionData';
import {
  getCountrySections,
  getPhaseName,
  getSectionApiKey,
  getSectionKey,
} from '../utils/getSectionData';
import { WIRPhaseSectionApiKeys, WIRSections } from '../wir.constants';

export const useProcessSaveWirResponse = () => {
  const wirFromState = useSelectedWIR();
  const { getSectionPayload } = useSectionData();
  const countryState = useCountryState();
  const processSaveWirResponse = useCallback(
    async (
      section: string,
      processSaveResponse: (wirResponse: WIR | null) => void,
      phase: string,
    ) => {
      const sectionKey = getSectionKey(section, getCountrySections(phase) as WIRSections);
      const sectionApiKey = getSectionApiKey(sectionKey, WIRPhaseSectionApiKeys);
      if (wirFromState?.wirNumber && sectionKey && sectionApiKey) {
        processSaveResponse(
          await wellGuardianApiClient.updateWIRGenericSection(
            wirFromState?.wirNumber,
            getSectionPayload(phase, sectionKey, getPhaseName(phase), sectionApiKey),
            countryState,
          ),
        );
      }
    },
    [countryState, getSectionPayload, wirFromState],
  );

  return processSaveWirResponse;
};
